module Sm.Core.Timer

open Fable.Core.JsInterop

let inline setTimeout ms (f: unit -> unit) =
    emitJsExpr<int> (f, ms) "setTimeout($0, $1)"

let inline clearTimeout id =
    emitJsExpr<unit> id "clearTimeout($0)"

let debounce ms f =
    let mutable id = 0
    fun () ->
        clearTimeout id
        id <- setTimeout ms f

let deferFor ms f =
    setTimeout ms f |> ignore
